import { parseDateValue } from './formatDate'

export const isValidDateDayJS = (date) => {
    return Boolean(parseDateValue(date))
}

